export default "__VITE_ASSET__CVRPUq_W__"